import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=3981ddb2&scoped=true&"
import script from "./PaymentStep.vue?vue&type=script&lang=js&"
export * from "./PaymentStep.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStep.vue?vue&type=style&index=0&id=3981ddb2&prod&scoped=true&lang=css&"
import style1 from "./PaymentStep.vue?vue&type=style&index=1&id=3981ddb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981ddb2",
  null
  
)

export default component.exports